import React from "react";
import { FooterAuth, HeaderAuth } from "@components/organisms";
import { PasswordResetRequestForm } from "@temp/components";
export var RequestPasswordReset = function RequestPasswordReset() {
  return React.createElement(React.Fragment, null, React.createElement(HeaderAuth, null), React.createElement(PasswordResetRequestForm, null), React.createElement(FooterAuth, null));
};